/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Notify_TitleInputs */

const cs_automation_notify_title = /** @type {(inputs: Automation_Notify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titulek notifikace`)
};

const en_automation_notify_title = /** @type {(inputs: Automation_Notify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification title`)
};

/**
* | output |
* | --- |
* | "Notification title" |
*
* @param {Automation_Notify_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_notify_title = /** @type {((inputs?: Automation_Notify_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Notify_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_notify_title(inputs)
	return cs_automation_notify_title(inputs)
});